import { Lock } from 'lucide-react';

import { DashboardErrorPage } from './DashboardErrorPage';

export function DashboardNoAccess() {
    return (
        <DashboardErrorPage
            icon={Lock}
            code="Error 403"
            title="You do not have access to this dashboard"
            message="It has been shared, but you have not been given access. Ask the owner or an admin to give you access."
        />
    );
}
